
export function FIDSMarquee() {
  return (
    <div
      className="w-full overflow-hidden py-2"
      style={{ backgroundColor: "#00c8d7" }}
    >
      <div className="fids-marquee-track whitespace-nowrap">
        <span className="text-white font-bold text-sm md:text-base inline-block px-8">
          Welcome to Port Moresby Jacksons International Airport — Papua New Guinea
        </span>
        <span className="text-white font-bold text-sm md:text-base inline-block px-8">
          Welcome to Port Moresby Jacksons International Airport — Papua New Guinea
        </span>
      </div>
    </div>
  );
}
